import { DOMWidgetModel, DOMWidgetView } from '@jupyter-widgets/base';
//import {Document, DocumentChangedEvent, ModelChangedEvent} from "document"
//import {Receiver, Fragment} from "protocol/receiver"
//import {keys, values} from "core/util/object"
import { name, version } from './metadata';
function bk_require(name) {
    return window.Bokeh.require(name);
}
const { keys, values } = Object;
const version_range = `^${version}`;
class BokehModel extends DOMWidgetModel {
    defaults() {
        return Object.assign(Object.assign({}, super.defaults()), { _model_name: 'BokehModel', _model_module: name, _model_module_version: version_range, _view_name: 'BokehView', _view_module: name, _view_module_version: version_range, combine_events: false, render_bundle: {} });
    }
}
BokehModel.serializers = Object.assign({}, DOMWidgetModel.serializers);
export { BokehModel };
export class BokehView extends DOMWidgetView {
    constructor(options) {
        super(options);
        this._document = null;
        this._blocked = false;
        this._idle = true;
        this._combine = true;
        this._msgs = [];
        const { Receiver } = bk_require('protocol/receiver');
        this._receiver = new Receiver();
        this.model.on('change:render_bundle', () => this.render());
        if (window.Jupyter != null &&
            window.Jupyter.notebook != null) {
            // Handle classic Jupyter notebook
            const events = window.require('base/js/events');
            events.on('kernel_idle.Kernel', () => this._process_msg());
        }
        else if (this.model.widget_manager.context != null) {
            // Handle JupyterLab and Voila
            const context = this.model.widget_manager.context;
            const statusChanged = context.session != null
                ? context.session.kernel.statusChanged
                : context.sessionContext.statusChanged;
            if (statusChanged != null) {
                statusChanged.connect((_, status) => {
                    if (status === 'idle') {
                        this._process_msg();
                    }
                });
            }
            else if (this.model.get('combine_events')) {
                console.warn('BokehView cannot combine events because Kernel idle status cannot be determined.');
                this._combine = false;
            }
        }
        else if (this.model.get('combine_events')) {
            console.warn('BokehView cannot combine events because Kernel idle status cannot be determined.');
            this._combine = false;
        }
        this.listenTo(this.model, 'msg:custom', (content, buffers) => this._consume_patch(content, buffers));
    }
    _process_msg() {
        if (this._msgs.length == 0) {
            this._idle = true;
            return;
        }
        this.send(this._msgs.shift());
    }
    render() {
        const bundle = JSON.parse(this.model.get('render_bundle'));
        const { docs_json, render_items, div } = bundle;
        this.el.innerHTML = div;
        const element = this.el.children[0];
        const json = values(docs_json)[0];
        const { Document } = bk_require('document');
        const { add_document_standalone } = bk_require('embed/standalone');
        this._document = Document.from_json(json);
        for (const item of render_items) {
            const roots = {};
            for (const root_id in item.roots) {
                roots[root_id] = element;
            }
            add_document_standalone(this._document, element, roots);
        }
        this._document.on_change((event) => this._change_event(event));
    }
    _combine_events(new_msg) {
        const new_msgs = [];
        for (const msg of this._msgs) {
            if (new_msg.kind != msg.kind) {
                new_msgs.push(msg);
            }
            else if (msg.kind == 'ModelChanged' && new_msg.kind == 'ModelChanged') {
                if (msg.model.id != new_msg.model.id || msg.attr != new_msg.attr) {
                    new_msgs.push(msg);
                }
            }
            else if (msg.kind == 'MessageSent' && new_msg.kind == 'MessageSent') {
                if (msg.msg_data.event_values.model == null ||
                    msg.msg_data.event_values.model.id !=
                        new_msg.msg_data.event_values.model.id ||
                    msg.msg_data.event_name != new_msg.msg_data.event_name) {
                    new_msgs.push(msg);
                }
            }
        }
        new_msgs.push(new_msg);
        return new_msgs;
    }
    _send(msg) {
        if (!this._idle && this._combine && this.model.get('combine_events')) {
            // Queue event and drop previous events on same model attribute
            this._msgs = this._combine_events(msg);
        }
        else {
            this._idle = false;
            this.send(msg);
        }
    }
    _change_event(event) {
        if (this._blocked) {
            this._events.push(event);
            return;
        }
        const { Serializer } = bk_require('core/serialization');
        const references = new Map();
        for (const model of event.document._all_models.values()) {
            references.set(model, model.ref());
        }
        const serializer = new Serializer({ references });
        const event_rep = serializer.encode(event);
        event_rep.event = 'jsevent';
        this._send(event_rep);
    }
    _consume_patch(content, buffers) {
        if (this._document == null) {
            return;
        }
        if (content.msg == 'patch') {
            const { payload } = content;
            this._receiver.consume(payload != null ? payload : buffers[0].buffer);
            const comm_msg = this._receiver.message;
            if (comm_msg != null && keys(comm_msg.content).length > 0) {
                this._blocked = true;
                try {
                    this._document.apply_json_patch(comm_msg.content, comm_msg.buffers);
                }
                finally {
                    this._blocked = false;
                    const events = [...this._events];
                    this._events = [];
                    for (const event of events) {
                        this._change_event(event);
                    }
                }
            }
        }
    }
}
